module.exports = __webpack_public_path__ + "static/profile-a480b78b2812b7f40673da176dc21275.jpg";